import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Wrench } from "lucide-react";
import { TIER_META } from "@/lib/billing";
import { useAuth } from "@/lib/auth";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const demo = params.get("demo") === "1";
  const tier = params.get("tier");
  // Re-fetch the server-verified subscription so app access reflects the new plan
  // (webhook / demo-trial already updated the garage). We never grant access from
  // this redirect itself — access is read from the garage subscription server-side.
  useEffect(() => { refresh(); }, [refresh]);
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-midnight to-midnight-2 px-6">
      <div className="w-full max-w-md rounded-2xl bg-card p-8 text-center shadow-xl">
        <div className="mb-5 flex items-center justify-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-midnight"><Wrench className="h-4 w-4 text-brand" /></div>
          <span className="font-display text-lg font-bold tracking-widest text-midnight">PRO GARAGES</span>
        </div>
        <CheckCircle2 className="mx-auto mb-3 h-14 w-14 text-success" />
        <h1 className="font-display text-3xl font-bold uppercase text-midnight">You&apos;re all set!</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {demo ? "Your 14-day free trial has started" : "Your subscription is active"}
          {tier && TIER_META[tier] ? ` on the ${TIER_META[tier].name} plan.` : "."}
        </p>
        <Link to="/dashboard" data-testid="success-dashboard-btn" className="mt-6 inline-block w-full rounded-lg bg-brand py-3.5 text-sm font-extrabold tracking-widest text-white">GO TO DASHBOARD</Link>
      </div>
    </div>
  );
}
